import {InvenTypeVo} from '../../../common/shared/api/gateway/enums/InvenTypeVo.enum';
import {TextTKey} from '../../../common/type';

// 전체 카테고리 선택 param
export const ALL_CATEGORY_UID = 0;
export const INVEN_SLICE_NAME = 'inven';

export const EDIT_PAGE_TITLE_MAP: Record<InvenTypeVo, TextTKey> = {
  [InvenTypeVo.Recent]: {
    text: '최근 본 편집',
    textTKey: 'library_tab_recent_edit',
  },
  [InvenTypeVo.Like]: {
    text: '좋아요 편집',
    textTKey: 'library_tab_like_edit',
  },
  [InvenTypeVo.Paid]: {
    text: '구매 작품 편집',
    textTKey: 'library_tab_purchase_edit',
  },
};

export const SEARCH_PAGE_PLACEHOLDER_MAP: Record<InvenTypeVo, TextTKey> = {
  [InvenTypeVo.Recent]: {
    text: '최근 본 작품 검색',
    textTKey: 'library_tab_recent_search',
  },
  [InvenTypeVo.Like]: {
    text: '좋아요 작품 검색',
    textTKey: 'library_tab_like_search',
  },
  [InvenTypeVo.Paid]: {
    text: '구매 작품 검색',
    textTKey: 'library_tab_purchase_search',
  },
};

export const REFETCH_INVEN_EVENT_NAME = 'refetchinven';

export const INVEN_TAB_TITLE_MAP: Record<InvenTypeVo, TextTKey> = {
  [InvenTypeVo.Like]: {
    text: '좋아요',
    textTKey: 'library_tab_like',
  },
  [InvenTypeVo.Recent]: {
    text: '최근 본',
    textTKey: 'library_tab_recent',
  },
  [InvenTypeVo.Paid]: {
    text: '구매 작품',
    textTKey: 'library_tab_purchase',
  },
};

export const SESSION_STORAGE_INVEN_SORT_OPTION_INFO = 'inven_sort_option_info';
